import CourseFavoriteCard from "../components/CourseFavoriteCard";
import FilterDashboard from "../components/FilterDashboard";
import "../styles/courses.css";

export default function FavoriteCourses({dashboardCard1Object}) {
  return (
    <div className="pageDashB">
      
 <FilterDashboard   dashboardCard1Object={dashboardCard1Object}/>
      <div className="courses-list">
        <CourseFavoriteCard
        dashboardCard1Object={dashboardCard1Object}
          title="Figma for UI/UX Design: A Complete Tutorial (Hindi) | How to Become UI/UX Designer in india"
          price="₹699.00"
          image="https://via.placeholder.com/280x180"
          itemId="190"
          category="Graphic Designing"
          duration="5:01 Hours"
          updated="3 Nov 2023"
          instructor="ankit shrivastava"
        /> <CourseFavoriteCard
         dashboardCard1Object={dashboardCard1Object}
          title="Figma for UI/UX Design: A Complete Tutorial (Hindi) | How to Become UI/UX Designer in india"
          price="₹699.00"
          image="https://via.placeholder.com/280x180"
          itemId="190"
          category="Graphic Designing"
          duration="5:01 Hours"
          updated="3 Nov 2023"
          instructor="ankit shrivastava"
        />
      </div>
    </div>
  );
}
